import './App.css';
import Header from './Component/Header/Header';
import Navigation from './Component/Navigation/Navigation';
import SportInfo from "./Component/Sport-Info/Sport-Info";

function App() {
  return (
    <div className="App flex flex-row">
        <Navigation />
        <div className="flex flex-col w-11/12">
            <Header />
            <SportInfo />
        </div>
    </div>
  );
}

export default App;
